import {
  ICreateSectionRequest,
  ICreateStaticPageRequest,
  IEditSectionRequest,
  IEditStaticPageRequest,
  ISectionListParams,
  ISectionsOrderRequest,
  IStaticPagesOrderRequest,
} from 'core/model/interfaces/static-pages';
import { staticPagesData } from './static-pages.data';
import {
  mapCreateSectionRequestDomainToDto,
  mapCreateStaticPageRequestDomainToDto,
  mapEditSectionRequestDomainToDto,
  mapEditStaticPageRequestDomainToDto,
  mapSectionListDtoToDomain,
  mapSectionParamsDomainToDto,
  mapSectionsOrderRequestDtoToDomain,
  mapStaticPageListDtoToDomain,
  mapStaticPagePriceGroupResponseDtoToDomain,
  mapStaticPageResponseDtoToDomain,
  mapStaticPagesOrderRequestDtoToDomain,
} from './static-pages.mapper';

export const staticPagesService = {
  getSectionList: async (params: ISectionListParams) => {
    const response = await staticPagesData.getSections(mapSectionParamsDomainToDto(params));
    return mapSectionListDtoToDomain(response);
  },
  createSection: async (body: ICreateSectionRequest) => {
    await staticPagesData.createSection(mapCreateSectionRequestDomainToDto(body));
  },
  editSection: async (body: IEditSectionRequest) => {
    await staticPagesData.editSection(mapEditSectionRequestDomainToDto(body));
  },
  deleteSection: async (id: string) => {
    await staticPagesData.deleteSection(id);
  },
  sortSections: async (body: ISectionsOrderRequest): Promise<void> => {
    await staticPagesData.sortSections(mapSectionsOrderRequestDtoToDomain(body));
  },
  getStaticPageList: async (id: string) => {
    const response = await staticPagesData.getStaticPageList(id);
    return mapStaticPageListDtoToDomain(response);
  },
  getStaticPageDetail: async (sectionId: string, staticPageId: string) => {
    const response = await staticPagesData.getStaticPageDetail(sectionId, staticPageId);
    return mapStaticPageResponseDtoToDomain(response);
  },
  createStaticPage: async (body: ICreateStaticPageRequest) => {
    const { sectionId } = body;
    await staticPagesData.createStaticPage(mapCreateStaticPageRequestDomainToDto(body), sectionId);
  },
  editStaticPage: async (body: IEditStaticPageRequest) => {
    const { sectionId, staticPageId } = body;
    await staticPagesData.editStaticPage(mapEditStaticPageRequestDomainToDto(body), sectionId, staticPageId);
  },
  deleteStaticPage: async (sectionId: string, staticPageId: string) => {
    await staticPagesData.deleteStaticPage(sectionId, staticPageId);
  },
  sortStaticPages: async (body: IStaticPagesOrderRequest): Promise<void> => {
    const { sectionId } = body;
    await staticPagesData.sortStaticPages(mapStaticPagesOrderRequestDtoToDomain(body), sectionId);
  },
  getGroupList: async () => {
    const response = await staticPagesData.getGroupList();
    return mapStaticPagePriceGroupResponseDtoToDomain(response);
  },
};
